import React from "react";
import EmptyState from '../../CommonComponents/EmptyState';
import { Package } from "lucide-react";
import { tableContainer, tableBase, tableHead, tableHeader, tableCell, tableRow } from '../../../utils/tableStyle';

// Utility function to format currency
const formatCurrency = (amount) => {
    if (isNaN(amount)) return "₱0.00";
    return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
        minimumFractionDigits: 2,
    }).format(amount);
};

const formatDateMMDDYYYY = (value) => {
    if (!value) return "-";
    const str = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
        const [yyyy, mm, dd] = str.split("-");
        return `${mm}/${dd}/${yyyy}`;
    }
    const parsed = new Date(str);
    if (Number.isNaN(parsed.getTime())) return str;
    return parsed.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
    });
};

export default function ReportsTable({ sales = [], loading = false, error = null }) {
    return (
        <div className={tableContainer}>
            <table className={tableBase}>
                <thead className={tableHead} style={{ background: 'var(--color-primary)' }}>
                    <tr>
                        <th className={tableHeader + ' text-left'}>No.</th>
                        <th className={tableHeader + ' text-left'}>Order #</th>
                        <th className={tableHeader + ' text-left'}>Date</th>
                        <th className={tableHeader + ' text-left'}>Total Sales</th>
                        <th className={tableHeader + ' text-left'}>Orders Count</th>
                        <th className={tableHeader + ' text-left'}>Branch</th>
                        <th className={tableHeader + ' text-left'}>Cashier</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr><td colSpan={7} className={tableCell + ' text-center py-8'}>Loading...</td></tr>
                    ) : error ? (
                        <tr><td colSpan={7} className={tableCell + ' text-center py-8 text-red-600'}>Error loading data</td></tr>
                    ) : sales.length === 0 ? (
                        <tr>
                            <td colSpan={7} className={tableCell + ' text-center py-8'}>
                                <div className="flex flex-col items-center justify-center">
                                    <EmptyState
                                        icon={Package}
                                        message="No sales found."
                                        size="default"
                                    />
                                </div>
                            </td>
                        </tr>
                    ) : (
                        sales.map((sale, idx) => (
                            <tr key={sale.id || idx} className={tableRow + ' border-b last:border-0'}>
                                <td className={tableCell}>{idx + 1}</td>
                                <td className={tableCell}>
                                    {Array.isArray(sale.order_numbers) && sale.order_numbers.length > 0
                                        ? sale.order_numbers.join(", ")
                                        : (sale.order_number || '-')}
                                </td>
                                <td className={tableCell + ' font-medium'}>{formatDateMMDDYYYY(sale.date)}</td>
                                <td className={tableCell}>{formatCurrency(sale.totalSales)}</td>
                                <td className={tableCell}>{sale.ordersCount}</td>
                                <td className={tableCell}>{sale.branch_name || '-'}</td>
                                <td className={tableCell}>{sale.cashier || '-'}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}
